const openExternalUrl = (url) => {
  const payload = {
    type: 'OPEN_URL',
    payload: {
      url
    }
  }

  if (window.ReactNativeWebView) {
    console.log('openExternalUrl (react native)')
    window.ReactNativeWebView.postMessage(JSON.stringify(payload))
  } else if (window.webkit) {
    console.log('openExternalUrl (webkit)')
    window.webkit.messageHandlers.pwaAction.postMessage(payload)
  } else if (window.JSInterface) {
    console.log('openExternalUrl (android)')
    window.JSInterface.postMessage(JSON.stringify(payload))
  } else {
    // try to load directly
    console.log('openExternalUrl (DOM fallback)')
    window.open(url, '_blank')
  }
}

export default function(ctx, inject) {
  const messages = {
    openExternalUrl
  }
  ctx.$appInterop = messages
  inject('appInterop', messages)
}
